module.exports = __webpack_public_path__ + "img/WidgetRoomMockup2.10c72286.jpg";